import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import AutoEposPriceItPlusForm from './auto-epos-price-it-plus-form';
import { createPipEposSubmission } from '../../../actions/pip-epos-submissions';

const model = 'deep.autoEposPriceItPlus';

class AutoEposPriceItPlusFormPage extends Component {
  handleOnSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(model, createPipEposSubmission(payload)));
  };

  render() {
    const { isLoading } = this.props;

    return (
      <div className="container-fluid">
        {isLoading ? 'Loading...' : (
          <AutoEposPriceItPlusForm model={model} onSubmit={this.handleOnSubmit} />
        )}
      </div>
    );
  }
}

export default connect(null)(AutoEposPriceItPlusFormPage);
